import { Checkbox as MUICheckbox } from '@mui/material';
import classNames from 'classnames';
import { memo } from 'react';
import css from './Checkbox.module.scss';
import { GMCheckboxProps } from '..';

const Checkbox: React.FC<GMCheckboxProps> = memo(({
    color = 'dark',
    ...props
}) => {
    return (
        <MUICheckbox
            checked={props.checked}
            disabled={props.disabled}
            onChange={props.onChange}
            className={classNames(css.root, {
                [css.light]: color === 'light',
                [css.dark]: color === 'dark',
                [css.error]: color === 'error',
                [css.disabled]: props.disabledButClickable,
            })}
        />
    );
});

export default Checkbox;